(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nicotine-calculator"] && !Shopify.designMode) return;
  try {
    
  class NicotineCalculator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.products = [];
      this.filteredProducts = [];
      this.selectedProduct = null;
      this.selectedVariant = null;
      this.activeResult = -1;
      this.mode = 'product';
      this.config = {
        productsUrl: this.dataset.productsUrl,
        cartAddUrl: this.dataset.cartAddUrl,
        cartUrl: this.dataset.cartUrl,
        boosterVariantId: Number(this.dataset.boosterVariantId),
        boosterPrice: Number(this.dataset.boosterPrice),
        boosterAvailable: this.dataset.boosterAvailable === 'true',
        boosterStrength: Number(this.dataset.boosterStrength),
        boosterVolume: Number(this.dataset.boosterVolume),
        currency: this.dataset.currency,
      };
      this.i18n = JSON.parse(this.querySelector('[data-calculator-translations]').textContent);
      this.searchInput = this.querySelector('[data-product-search]');
      this.results = this.querySelector('[data-product-results]');
      this.productsStatus = this.querySelector('[data-products-status]');
      this.variantSelect = this.querySelector('[data-variant-select]');
      this.targetInput = this.querySelector('[data-target-rate]');
      this.addButton = this.querySelector('[data-add-to-cart]');
      this.mobileResult = this.querySelector('[data-mobile-result]');
      this.resultPanel = this.querySelector('.nicotine-calculator__result-panel');
      this.bindEvents();
      this.observeResult();
      this.loadProducts();
      this.calculate();
    }

    bindEvents() {
      this.querySelectorAll('input[type="radio"][name^="calculator-mode-"]').forEach((input) => {
        input.addEventListener('change', () => this.setMode(input.value));
      });
      this.searchInput.addEventListener('input', () => this.searchProducts());
      this.searchInput.addEventListener('focus', () => this.searchProducts());
      this.searchInput.addEventListener('keydown', (event) => this.handleSearchKeys(event));
      this.querySelector('[data-clear-product]').addEventListener('click', () => this.clearProduct());
      this.variantSelect.addEventListener('change', () => this.syncVariant());
      this.querySelectorAll('[data-product-volume], [data-product-current], [data-custom-volume], [data-custom-current], [data-target-rate]').forEach((input) => {
        input.addEventListener('input', () => this.calculate());
      });
      this.querySelectorAll('[data-rate]').forEach((button) => {
        button.addEventListener('click', () => {
          this.targetInput.value = button.dataset.rate;
          this.querySelectorAll('[data-rate]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          this.calculate();
        });
      });
      this.addButton.addEventListener('click', () => this.addToCart());
      this.querySelector('[data-view-result]').addEventListener('click', () => {
        this.resultPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeResults();
      });
    }

    observeResult() {
      this.resultObserver = new IntersectionObserver((entries) => {
        this.mobileResult.classList.toggle('is-result-visible', entries[0].isIntersecting);
      }, { threshold: 0.18 });
      this.resultObserver.observe(this.resultPanel);
    }

    async loadProducts() {
      try {
        const response = await fetch(this.config.productsUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Products unavailable');
        const data = await response.json();
        this.products = data.products.filter((product) => product.variants.some((variant) => variant.available));
        this.productsStatus.textContent = this.i18n.productsReady.replace('[count]', this.products.length);
      } catch (error) {
        this.productsStatus.textContent = this.i18n.productsError;
        this.searchInput.disabled = true;
      }
    }

    normalize(value) {
      return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    searchProducts() {
      const query = this.normalize(this.searchInput.value).trim();
      if (!this.products.length) return;
      this.filteredProducts = this.products.filter((product) => {
        const haystack = this.normalize([product.title, product.vendor, product.product_type].join(' '));
        return !query || haystack.includes(query);
      }).slice(0, 9);
      this.activeResult = -1;
      this.renderResults();
    }

    renderResults() {
      this.results.replaceChildren();
      if (!this.filteredProducts.length) {
        const item = document.createElement('li');
        item.className = 'nicotine-calculator__field-note';
        item.textContent = this.i18n.noProducts;
        this.results.append(item);
      } else {
        this.filteredProducts.forEach((product, index) => {
          const item = document.createElement('li');
          const button = document.createElement('button');
          button.type = 'button';
          button.role = 'option';
          button.dataset.resultIndex = index;
          button.setAttribute('aria-selected', String(index === this.activeResult));
          const image = document.createElement('img');
          image.loading = 'lazy';
          image.alt = '';
          image.src = product.images?.[0]?.src || '';
          const copy = document.createElement('span');
          const title = document.createElement('strong');
          title.textContent = product.title;
          const vendor = document.createElement('small');
          vendor.textContent = product.vendor || product.product_type || '';
          const price = document.createElement('strong');
          price.textContent = this.formatMoney(this.lowestPrice(product));
          copy.append(title, vendor);
          button.append(image, copy, price);
          button.addEventListener('click', () => this.selectProduct(product));
          item.append(button);
          this.results.append(item);
        });
      }
      this.results.hidden = false;
      this.searchInput.setAttribute('aria-expanded', 'true');
    }

    handleSearchKeys(event) {
      if (this.results.hidden && event.key === 'ArrowDown') {
        this.searchProducts();
        event.preventDefault();
        return;
      }
      if (!['ArrowDown', 'ArrowUp', 'Enter', 'Escape'].includes(event.key)) return;
      if (event.key === 'Escape') {
        this.closeResults();
        return;
      }
      if (event.key === 'Enter' && this.activeResult >= 0) {
        event.preventDefault();
        this.selectProduct(this.filteredProducts[this.activeResult]);
        return;
      }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const direction = event.key === 'ArrowDown' ? 1 : -1;
        this.activeResult = (this.activeResult + direction + this.filteredProducts.length) % this.filteredProducts.length;
        this.results.querySelectorAll('[role="option"]').forEach((button, index) => {
          button.setAttribute('aria-selected', String(index === this.activeResult));
          if (index === this.activeResult) button.scrollIntoView({ block: 'nearest' });
        });
      }
    }

    closeResults() {
      this.results.hidden = true;
      this.searchInput.setAttribute('aria-expanded', 'false');
    }

    selectProduct(product) {
      this.selectedProduct = product;
      this.searchInput.value = product.title;
      this.closeResults();
      const availableVariants = product.variants.filter((variant) => variant.available);
      this.variantSelect.replaceChildren();
      availableVariants.forEach((variant) => {
        const option = document.createElement('option');
        option.value = variant.id;
        option.textContent = `${variant.title} — ${this.formatMoney(this.priceToCents(variant.price))}`;
        this.variantSelect.append(option);
      });
      const preferredVariant = [...availableVariants].sort((a, b) => this.extractNicotine(a.title) - this.extractNicotine(b.title))[0];
      this.variantSelect.value = preferredVariant.id;
      this.querySelector('[data-variant-field]').hidden = availableVariants.length < 2;
      this.querySelector('[data-product-details]').hidden = false;
      this.querySelector('[data-selected-product]').hidden = false;
      this.querySelector('[data-selected-title]').textContent = product.title;
      const image = this.querySelector('[data-selected-image]');
      image.src = product.images?.[0]?.src || '';
      image.alt = product.title;
      this.syncVariant();
    }

    syncVariant() {
      this.selectedVariant = this.selectedProduct.variants.find((variant) => String(variant.id) === this.variantSelect.value);
      const volume = this.extractVolume([
        this.selectedProduct.title,
        this.selectedVariant.title,
        this.selectedProduct.body_html,
        this.selectedProduct.images?.[0]?.src,
      ].join(' '));
      const nicotineSource = this.selectedVariant.title === 'Default Title'
        ? `${this.selectedProduct.title} ${this.selectedProduct.body_html}`
        : this.selectedVariant.title;
      const currentRate = this.extractNicotine(nicotineSource);
      this.querySelector('[data-product-volume]').value = volume || '';
      this.querySelector('[data-product-current]').value = currentRate;
      const meta = [
        this.selectedVariant.title !== 'Default Title' ? this.selectedVariant.title : '',
        this.formatMoney(this.priceToCents(this.selectedVariant.price)),
        volume ? this.i18n.volumeDetected.replace('[volume]', this.formatNumber(volume)) : '',
        this.i18n.currentDetected.replace('[rate]', this.formatNumber(currentRate)),
      ].filter(Boolean).join(' · ');
      this.querySelector('[data-selected-meta]').textContent = meta;
      this.calculate();
    }

    clearProduct() {
      this.selectedProduct = null;
      this.selectedVariant = null;
      this.searchInput.value = '';
      this.querySelector('[data-selected-product]').hidden = true;
      this.querySelector('[data-product-details]').hidden = true;
      this.querySelector('[data-variant-field]').hidden = true;
      this.calculate();
      this.searchInput.focus();
    }

    setMode(mode) {
      this.mode = mode;
      this.querySelectorAll('[data-mode-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.modePanel !== mode;
      });
      this.closeResults();
      this.calculate();
    }

    extractVolume(value) {
      const matches = [...String(value || '').matchAll(/(\d+(?:[.,]\d+)?)\s*ml\b/gi)];
      const values = matches.map((match) => Number(match[1].replace(',', '.'))).filter((number) => number > 0 && number <= 1000);
      return values.length ? values[values.length - 1] : 0;
    }

    extractNicotine(value) {
      const match = String(value || '').match(/(\d+(?:[.,]\d+)?)\s*mg(?:\s*\/\s*ml)?/i);
      return match ? Number(match[1].replace(',', '.')) : 0;
    }

    calculate() {
      const empty = this.querySelector('[data-empty-result]');
      const result = this.querySelector('[data-calculation]');
      const error = this.querySelector('[data-calculation-error]');
      error.hidden = true;
      let volume;
      let currentRate;
      if (this.mode === 'product') {
        if (!this.selectedVariant) return this.showEmpty(this.i18n.selectProduct);
        volume = Number(this.querySelector('[data-product-volume]').value);
        currentRate = Number(this.querySelector('[data-product-current]').value);
      } else {
        volume = Number(this.querySelector('[data-custom-volume]').value);
        currentRate = Number(this.querySelector('[data-custom-current]').value);
      }
      const targetRate = Number(this.targetInput.value);
      if (!Number.isFinite(volume) || volume <= 0) return this.showError(this.i18n.invalidVolume);
      if (!Number.isFinite(currentRate) || !Number.isFinite(targetRate) || currentRate < 0 || targetRate < 0) return this.showError(this.i18n.invalidRate);
      if (targetRate < currentRate) return this.showError(this.i18n.rateTooLow.replace('[current]', this.formatNumber(currentRate)));
      if (targetRate >= this.config.boosterStrength && targetRate > currentRate) return this.showError(this.i18n.rateTooHigh);

      const exactVolume = targetRate === currentRate
        ? 0
        : volume * (targetRate - currentRate) / (this.config.boosterStrength - targetRate);
      const boosterEquivalent = exactVolume / this.config.boosterVolume;
      const bottleCount = exactVolume > 0 ? Math.ceil(boosterEquivalent - 0.000001) : 0;
      const fullBottles = Math.floor(boosterEquivalent + 0.000001);
      const partialVolume = Math.max(0, exactVolume - fullBottles * this.config.boosterVolume);
      const remaining = Math.max(0, bottleCount * this.config.boosterVolume - exactVolume);
      const finalVolume = volume + exactVolume;
      const allBottlesRate = bottleCount > 0
        ? (currentRate * volume + this.config.boosterStrength * bottleCount * this.config.boosterVolume) / (volume + bottleCount * this.config.boosterVolume)
        : currentRate;

      empty.hidden = true;
      result.hidden = false;
      this.querySelector('[data-exact-volume]').textContent = this.formatNumber(exactVolume, 2);
      this.querySelector('[data-bottle-count]').textContent = bottleCount;
      this.querySelector('[data-bottle-label]').textContent = bottleCount === 1 ? this.i18n.boosterSingular : this.i18n.boosterPlural;
      this.querySelector('[data-final-volume]').textContent = this.formatNumber(finalVolume, 2);
      this.querySelector('[data-booster-equivalent]').textContent = this.formatNumber(boosterEquivalent, 2);
      this.querySelector('[data-booster-remaining]').textContent = this.formatNumber(remaining, 2);
      this.mobileResult.hidden = false;
      this.querySelector('[data-mobile-exact-volume]').textContent = this.formatNumber(exactVolume, 2);
      this.querySelector('[data-mobile-bottle-count]').textContent = bottleCount;
      this.querySelector('[data-mobile-bottle-label]').textContent = bottleCount === 1 ? this.i18n.boosterSingular : this.i18n.boosterPlural;

      let breakdown = this.i18n.noBooster;
      if (bottleCount > 0 && partialVolume < 0.005) {
        const bottleText = fullBottles === 1 ? this.i18n.fullBottle : this.i18n.fullBottles;
        breakdown = bottleText.replace('[count]', fullBottles);
      } else if (bottleCount > 0) {
        const fullText = fullBottles > 0
          ? (fullBottles === 1 ? this.i18n.fullBottle : this.i18n.fullBottles).replace('[count]', fullBottles)
          : '';
        const partialText = this.i18n.partialBottle.replace('[volume]', this.formatNumber(partialVolume, 2));
        breakdown = [fullText, partialText].filter(Boolean).join(' + ');
      }
      this.querySelector('[data-breakdown]').textContent = breakdown;
      const allBottlesNote = this.querySelector('[data-all-bottles-note]');
      allBottlesNote.hidden = remaining < 0.005;
      allBottlesNote.textContent = this.i18n.allBottlesNote.replace('[count]', bottleCount).replace('[rate]', this.formatNumber(allBottlesRate, 2));
      this.updateCartSummary(bottleCount);
    }

    showEmpty(message) {
      const empty = this.querySelector('[data-empty-result]');
      this.querySelector('[data-calculation]').hidden = true;
      this.querySelector('[data-calculation-error]').hidden = true;
      empty.hidden = false;
      empty.querySelector('p').textContent = message;
      this.mobileResult.hidden = true;
      this.addButton.disabled = true;
    }

    showError(message) {
      this.querySelector('[data-empty-result]').hidden = true;
      this.querySelector('[data-calculation]').hidden = true;
      const error = this.querySelector('[data-calculation-error]');
      error.textContent = message;
      error.hidden = false;
      this.mobileResult.hidden = true;
      this.addButton.disabled = true;
    }

    updateCartSummary(bottleCount) {
      const summary = this.querySelector('[data-cart-summary]');
      summary.replaceChildren();
      let total = 0;
      if (this.mode === 'product' && this.selectedVariant) {
        const row = document.createElement('span');
        const label = document.createElement('span');
        label.textContent = this.i18n.liquidLine.replace('[title]', this.selectedProduct.title);
        const price = document.createElement('strong');
        const cents = this.priceToCents(this.selectedVariant.price);
        price.textContent = this.formatMoney(cents);
        total += cents;
        row.append(label, price);
        summary.append(row);
      }
      if (bottleCount > 0) {
        const row = document.createElement('span');
        const label = document.createElement('span');
        label.textContent = this.i18n.boosterLine.replace('[count]', bottleCount);
        const price = document.createElement('strong');
        const cents = this.config.boosterPrice * bottleCount;
        price.textContent = this.formatMoney(cents);
        total += cents;
        row.append(label, price);
        summary.append(row);
      }
      const label = this.querySelector('[data-cta-label]');
      if (this.mode === 'product' && bottleCount > 0) label.textContent = this.i18n.addAll;
      else if (this.mode === 'product') label.textContent = this.i18n.addLiquid;
      else if (bottleCount > 0) label.textContent = this.i18n.addBoosters;
      else label.textContent = this.i18n.nothingToAdd;
      this.querySelector('[data-cta-price]').textContent = total > 0 ? this.formatMoney(total) : '';
      const hasLiquid = this.mode === 'product' && this.selectedVariant?.available;
      const hasBoosters = bottleCount > 0 && this.config.boosterAvailable;
      this.currentBottleCount = bottleCount;
      this.addButton.disabled = !(hasLiquid || hasBoosters) || (bottleCount > 0 && !this.config.boosterAvailable);
    }

    async addToCart() {
      const items = [];
      if (this.mode === 'product' && this.selectedVariant?.available) items.push({ id: Number(this.selectedVariant.id), quantity: 1 });
      if (this.currentBottleCount > 0) items.push({ id: this.config.boosterVariantId, quantity: this.currentBottleCount });
      if (!items.length) return;
      const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')].map((item) => item.dataset.sectionId);
      const status = this.querySelector('[data-cart-status]');
      const ctaLabel = this.querySelector('[data-cta-label]');
      const previousLabel = ctaLabel.textContent;
      this.addButton.disabled = true;
      ctaLabel.textContent = this.i18n.adding;
      status.textContent = '';
      try {
        const response = await fetch(this.config.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: sectionIds.join(','), sections_url: window.location.pathname }),
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || this.i18n.cartError);
        const cartResponse = await fetch(this.config.cartUrl, { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: this.id || 'nicotine-calculator',
            data: { source: 'nicotine-calculator', itemCount: cart.item_count, sections: data.sections },
          },
        }));
        ctaLabel.textContent = this.i18n.added;
        status.textContent = this.i18n.added;
        setTimeout(() => {
          ctaLabel.textContent = previousLabel;
          this.addButton.disabled = false;
        }, 1800);
      } catch (error) {
        ctaLabel.textContent = previousLabel;
        status.textContent = error.message || this.i18n.cartError;
        this.addButton.disabled = false;
      }
    }

    lowestPrice(product) {
      return Math.min(...product.variants.filter((variant) => variant.available).map((variant) => this.priceToCents(variant.price)));
    }

    priceToCents(value) {
      return Math.round(Number(value) * 100);
    }

    formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: this.config.currency || 'EUR',
      }).format(cents / 100);
    }

    formatNumber(value, digits = 1) {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        maximumFractionDigits: digits,
      }).format(Number(value));
    }
  }

  if (!customElements.get('nicotine-calculator')) {
    customElements.define('nicotine-calculator', NicotineCalculator);
  }

  } catch(e) { console.error(e); }
})();
})();
